import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Card,
  CardContent,
  Chip,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import moment from "moment";
import StarIcon from "@mui/icons-material/Star";
import { styled } from "@mui/system";
import { SHRIMP_DATA_BY_MOBILE_NO } from "../../../constants";

// Styled components using @mui/system
const StyledCard = styled(Card)({
  marginBottom: "20px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
});

const CardHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "10px",
});

const StatusChip = styled(Chip)(({ theme, actionType }) => ({
  fontWeight: "bold",
  padding: "8px 12px",
  borderRadius: "16px",
  background: actionType === "Open" ? "rgb(16, 204, 82)" : "rgb(204, 16, 82)",
  color: "#fff",
  textTransform: "capitalize",
  marginBottom: "5px",
}));

const DateText = styled("div")({
  fontSize: "14px",
  fontWeight: 600,
  color: "#444",
});

const Title = styled(Typography)({
  marginBottom: "10px",
  fontSize: "16px",
  fontWeight: "500",
});

const Content = styled("div")({
  whiteSpace: "normal",
  wordWrap: "break-word",
  overflowWrap: "break-word",
});

const ExistingTimelineComponent = ({ FormMobileNo }) => {
  const [timelineData, setTimelineData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (FormMobileNo !== "") {
      fetchDataByMobileNo(FormMobileNo);
    }
  }, [FormMobileNo]);

  const fetchDataByMobileNo = (mobNo) => {
    if (mobNo.length === 10) {
      setLoading(true); // Start loading
      axios
        .get(`${SHRIMP_DATA_BY_MOBILE_NO}/${mobNo}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
        .then((response) => {
          const { masterDetails } = response.data.data;

          if (!masterDetails || Object.keys(masterDetails).length === 0) {
            // Handle case where lead is empty or null
            return; // Exit early
          }

          if (
            response.data.message === "No records found for this mobile number"
          ) {
            setTimelineData([]);
          } else {
            // Populate the state variables with the fetched lead data
            setTimelineData(masterDetails.feedRemarks);
          }
        })
        .catch((error) => {
          console.log(error);
          setTimelineData([]);
          // setMobileNumberError("Failed to fetch data. Please try again.");
        })
        .finally(() => {
          setLoading(false); // Stop loading
        });
    }
  };

  const formatDate = (date) => {
    return moment(date).format("MMMM D, YYYY, h:mm A");
  };

  console.log(timelineData, "-------------");

  const fallback = (value, suffix = "") =>
    value === null || value === undefined || value === ""
      ? "-"
      : `${value}${suffix}`;

  return (
    <>
      {loading ? (
        <div>Loading...</div>
      ) : timelineData?.length > 0 ? (
       <div 
       style={{
        maxHeight: "calc(100vh - 50px)", // Adjust the height based on your layout
        overflowY: timelineData?.length > 4 ? "auto" : "visible", // Show scroll if there are more than 4 cards
      }}>
        {timelineData?.map((log, index) => (
          <StyledCard key={index}>
            <CardContent>
              <CardHeader>
                <DateText>
                  <strong>Last Action Date: &nbsp;</strong>
                  {log.updatedAt ? formatDate(log.updatedAt) : "-"}
                </DateText>
                <StarIcon
                  sx={{
                    backgroundColor: "rgb(16, 204, 82)",
                    color: "#fff",
                    borderRadius: "50%",
                    padding: "5px",
                  }}
                />
              </CardHeader>

              <StatusChip label={log.status} actionType={log.status} />

              <Title variant="h5">
                <strong>Farmer Name:&nbsp;</strong>
                <strong>{log.name}</strong>
              </Title>
              <Divider />

              <Content>
                <strong>Type:</strong> {fallback(log.type)}
                <br />
                <strong>Purpose:</strong> {fallback(log.purpose)}
                <br />
                <strong>Category:</strong>{" "}
                {fallback(log.prospectFarmerCategory)}
                <br />
                <strong>Postal Code:</strong> {fallback(log.postalCode)}
                <br />
                <strong>State:</strong> {fallback(log.state)}
                <br />
                <strong>District:</strong> {fallback(log.district)}
                <br />
                <strong>No. of Pond:</strong> {fallback(log.numberOfPonds)}
                <br />
                <strong>Pond Location:</strong> {fallback(log.pondLocation)}
                <br />
                <strong>Pond Area:</strong>{" "}
                {fallback(log.pondAreaInAcres, " Acres")}
                <br />
                <strong>Days of Culture:</strong>{" "}
                {fallback(log.daysOfCulture, " days")}
                <br />
                <strong>Fish Species:</strong> {fallback(log.fishSpecies)}
                <br />
                <strong>Current Feed:</strong> {fallback(log.currentFeedUsed)}
                <br />
                <strong>Follow-Up date:</strong>{" "}
                {fallback(formatDate(log.followUpDate))}
                <br />
                <strong>Harvesting:</strong> {fallback(log.isHarvesting)}
                <br />
                <strong>Harvesting Quantity:</strong>{" "}
                {fallback(log.harvestingQuantity)}
                <br />
                <strong>Stocking:</strong> {fallback(log.isStocking)}
                <br />
                <strong>Stocking Density:</strong>{" "}
                {fallback(log.stockingDensity)}
                <br />
                <strong>Potentiality in MT:</strong>{" "}
                {fallback(log.potentialityInMT)}
                <br />
              </Content>

              {/* Displaying remarks */}
              <div>
                <strong>Remark updated by:</strong>
                {log.agentRemarks ? (
                  <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                    <li key={log.id} style={{ marginBottom: "10px" }}>
                      ({log.createdAt ? formatDate(log.createdAt) : "N/A"}) -{" "}
                      {log.agentRemarks || "No Remarks"}
                      <br />
                    </li>
                  </ul>
                ) : (
                  <p>No remarks available.</p>
                )}
              </div>
            </CardContent>
          </StyledCard>

        ))}
        </div>
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100%"
          padding={2}
          sx={{
            border: "1px dashed #ccc",
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
            color: "#666",
            textAlign: "center",
          }}
        >
          <Typography variant="h6" sx={{ marginBottom: 1, color: "#444" }}>
            No Existing Records
          </Typography>
          <Typography variant="body2">
            We couldn't find any records to display at the moment.
          </Typography>
          <Box mt={2}>
            {/* <img
                  src="https://via.placeholder.com/150"
                  alt="No Records"
                  style={{ width: "100px", height: "100px", opacity: 0.7 }}
                /> */}
          </Box>
        </Box>
      )}
    </>
  );
};

export default ExistingTimelineComponent;
